import { Subject, timer } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { AggregateApi } from '~/api/aggregate';

export interface AggregateFile {
  id: number;
  inQueue: boolean;
  created: string;
  principalName: string;
  fileIdentity: string;
  submissionYear: string;
}

class AggregateServiceClass {
  getAggregateFiles() {
    return timer(0, 60000).pipe(
      concatMap(() => {
        const subject = new Subject<AggregateFile[]>();

        AggregateApi.getAll().then((data) => {
          subject.next(data);
          subject.complete();
        });

        return subject;
      })
    );
  }

  delete(id: number) {
    const subject = new Subject();

    AggregateApi.deleteById(id).then(() => subject.next(undefined));

    return subject;
  }
}

export const AggregateService = new AggregateServiceClass();
